import { useState } from 'react'

import { CommonSmallVerticalArrowIcon, FooterNaverIcon } from '@local/assets/icons'
import { CLICK_CODE, commonLinks } from '@local/utils'

import Clickable from '@web/ui/components/Clickable'

import styles from './Footer.module.scss'

interface FunctionFooterProps {
  login: boolean
  goToLogin: () => void
  goToLogout: () => void
}
export default function Footer(props: FunctionFooterProps) {
  const { login, goToLogin, goToLogout } = props

  const [showInfo, setShowInfo] = useState(false)

  const handleShowInfo = () => {
    setShowInfo(!showInfo)
  }

  return (
    <footer className={styles.footer}>
      <div className={styles.footer_area}>
        <div className={styles.btn_area}>
          <div className={styles.btn_inner}>
            <span className={styles.btn_wrapper}>
              {login ? (
                <Clickable className={styles.btn} onClick={goToLogout} nClickCode={CLICK_CODE['myfooter.logout']}>
                  로그아웃
                </Clickable>
              ) : (
                <Clickable className={styles.btn} onClick={goToLogin} /* nClickCode={CLICK_CODE['myfooter.login']} */>
                  로그인
                </Clickable>
              )}
            </span>
            <span className={styles.btn_wrapper}>
              <Clickable
                className={styles.btn}
                href={commonLinks.ALL_SERVICE}
                newWindow={true}
                nClickCode={CLICK_CODE['myfooter.allservices']}
              >
                전체서비스
              </Clickable>
            </span>
          </div>

          <div className={styles.btn_inner}>
            <span className={styles.btn_wrapper}>
              <Clickable
                className={styles.btn}
                newWindow={true}
                href={commonLinks.NAVER_BOOKING_CUSTOMER_SERVICE_CENTER}
                nClickCode={CLICK_CODE['myfooter.customerserviceforbooking']}
              >
                네이버 예약 고객센터
              </Clickable>
            </span>
            <span className={styles.btn_wrapper}>
              <Clickable
                className={styles.btn}
                newWindow={true}
                href={commonLinks.MYPLACE_CUSTOMER_SERVICE_CENTER}
                nClickCode={CLICK_CODE['myfooter.customerserviceformyplace']}
              >
                MY플레이스 고객센터
              </Clickable>
            </span>
          </div>

          <div className={styles.btn_inner}>
            <span className={styles.btn_wrapper}>
              <Clickable
                className={styles.btn}
                newWindow={true}
                href={commonLinks.NAVER_BOOKING_TERMS_OF_SERVICE}
                nClickCode={CLICK_CODE['myfooter.termsofserviceforbooking']}
              >
                네이버 예약 이용약관
              </Clickable>
            </span>
            <span className={styles.btn_wrapper}>
              <Clickable
                className={styles.btn}
                newWindow={true}
                href={commonLinks.NAVER_MAPS_TERMS_OF_SERVICE}
                nClickCode={CLICK_CODE['myfooter.termsofserviceformap']}
              >
                네이버 지도 서비스 이용약관
              </Clickable>
            </span>
          </div>
          <div className={styles.btn_inner}>
            <span className={styles.btn_wrapper}>
              <Clickable
                className={styles.btn}
                newWindow={true}
                href={commonLinks.MYPLACE_REVIEW_POLICY}
                nClickCode={CLICK_CODE['myfooter.termsofserviceforplacereview']}
              >
                플레이스 리뷰 이용약관
              </Clickable>
            </span>
            <span className={styles.btn_wrapper}>
              <Clickable
                className={styles.btn}
                newWindow={true}
                href={commonLinks.PRIVACY_RULES}
                nClickCode={CLICK_CODE['myfooter.privacypolicy']}
              >
                <strong>개인정보처리방침</strong>
              </Clickable>
            </span>
          </div>
        </div>
        <div className={styles.business_info_area}>
          <Clickable
            className={styles.btn_more}
            aria-expanded={showInfo}
            onClick={handleShowInfo}
            nClickCode={CLICK_CODE['myfooter.formoreinformation']}
          >
            네이버(주) 사업자 정보
            <CommonSmallVerticalArrowIcon className={styles.icon} aria-hidden="true" />
          </Clickable>
          {showInfo && (
            <ul className={styles.info_list}>
              <li className={styles.list_item}>
                <span className={styles.tit_area}>대표이사</span>
                <span className={styles.txt_area}>최수연</span>
              </li>
              <li className={styles.list_item}>
                <span className={styles.tit_area}>주소</span>
                <span className={styles.txt_area}>경기도 성남시 분당구 정자일로 95 NAVER 1784, 13561</span>
              </li>
              <li className={styles.list_item}>
                <span className={styles.tit_area}>전화번호</span>
                <span className={styles.txt_area}>1588-3820</span>
              </li>
              <li className={styles.list_item}>
                <span className={styles.tit_area}>이메일</span>
                <span className={styles.txt_area}>
                  <Clickable href={'mailto:helpcustomer@naver.com'} className={styles.link}>
                    helpcustomer@naver.com
                  </Clickable>
                </span>
              </li>
              <li className={styles.list_item}>
                <span className={styles.tit_area}>사업자등록번호</span>
                <span className={styles.txt_area}>220-81-62517</span>
              </li>
              <li className={styles.list_item}>
                <span className={styles.tit_area}>통신판매업신고번호</span>
                <span className={styles.txt_area}>제2006-경기성남-692호</span>
              </li>
              <li className={styles.list_item}>
                <span className={styles.tit_area}>호스팅 서비스 제공</span>
                <span className={styles.txt_area}>NAVER Cloud</span>
              </li>
            </ul>
          )}
        </div>
        <div className={styles.disclaimer_area}>
          네이버(주)는 통신판매의 당사자가 아니며, 상품의 정보, 거래조건, 이용 및 환불, 쿠폰 사용 등과 관련한 의무와
          책임은 각 판매자에게 있습니다.
        </div>
        <div className={styles.logo_area}>
          <Clickable className={styles.btn} newWindow={true} href={commonLinks.NAVER_CORP}>
            <FooterNaverIcon className={styles.icon} aria-hidden="true" />
            <span className="place_blind">NAVER</span>
          </Clickable>
        </div>
      </div>
    </footer>
  )
}
